export default {
	data() {
		return {
			activeName: "list",
			fakeTabs: {}
		};
	},
	mounted() {
		this.refreshRoute();
	},

	methods: {
		refreshRoute(tab = null) {
			if (!tab && this.$route.params.tab) {
				this.activeName = this.$route.params.tab;
			} else if (tab) {
				this.activeName = tab;
			}
		}
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: {
			handler(val) {
				if (val && val.params.tab != this.activeName) {
					this.refreshRoute();
				}
			},
			immediate: true,
			deep: true
		},
		activeName(val, old) {
			if (val != old && this.$route.params.tab != val) {
				if (this.fakeTabs[val]) {
					this.$router.push(this.fakeTabs[val]);
				} else {
					let params = Object.assign({}, this.$route.params);
					params.tab = val;
					this.$router.replace({
						name: this.$route.name,
						params: params
					});
				}
			}
		}
	}
};
